export const MEMBER_ACCOUNT_STATE = {
    ACTIVE: 'Active',
    TEMPORARY_SUSPENDED: 'TemporarySuspended',
    PERMANENTLY_SUSPENDED: 'PermanentlySuspended',
    DEREGISTERED: 'Deregistered'
};
